import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './../portal/header/header.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatExpansionModule } from '@angular/material/expansion';

import { HttpClient } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingComponent } from './components/loading/loading.component';
import { M4storeMessageComponent } from '../store/m4store-message/m4store-message.component';
import { DatiFatturazioneComponent } from '../store/components/dati-fatturazione/dati-fatturazione.component';
//import { IndustryAlacarteBoxComponent } from '../store/components/industry-alacarte-box/industry-alacarte-box.component';
import { MatStepperModule } from '@angular/material/stepper';
import { ShoppingCompactCardComponent } from './cards/shopping-compact-card/shopping-compact-card.component';
import { ShoppingAmazonDSPCardComponent } from './cards/shopping-amazon-dsp-card/shopping-amazon-dsp-card.component';
import { Mago4VsMagocloudCardComponent } from './cards/mago4-vs-magocloud-card/mago4-vs-magocloud-card.component';
import { HelpStoreCardComponent } from './cards/help-store-card/help-store-card.component';
import { CMSCardComponent } from './cards/CMS-card/CMS-card.component';
import { CMSEditorIndustriesComponent } from './cards/cms-editor-industries/cms-editor-industries.component';
import { AccountManagementCardComponent } from './cards/account-management-card/account-management-card.component';
import { SubscriptionManagementCardComponent } from './cards/subscription-management-card/subscription-management-card.component';
import { ImportExportManagementCardComponent } from './cards/import-export-management-card/import-export-management-card.component';
import { NfsCardComponent } from './cards/nfs-card/nfs-card.component';
import { GenericCardComponentComponent } from './cards/generic-card-component/generic-card-component.component';
import { DocCardComponentComponent } from './cards/doc-card-component/doc-card-component.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CountrySelectionComponent } from './components/country-selection/country-selection.component';
import { IndustryHeaderComponent } from './industry-header/industry-header.component';
import { FunctionalitiesSelectionComponent } from './components/functionalities-selection/functionalities-selection.component';
import { FeatureElementComponent } from '../store/components/feature-element/feature-element.component';
import { A2fConfiguratorComponent } from './components/a2f-configurator/a2f-configurator.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UnsavedChangesGuard } from '../cmseditor/guards/unsaved-changes.guard';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { AccountFeaturesComponent } from './components/account-features/account-features.component';
import { SpecializedFeaturesSelectionComponent } from './components/specializedfeatures-selection/specializedfeatures-selection.component';
import { UserDocumentsListComponent } from './components/user-documents-list/user-documents-list.component';
import { PrivacyAgreement } from '../shared/components/privacy-agreement/privacy-agreement.component';
import { PartnersRegistryCardComponent } from './cards/partners-registry-card/partners-registry-card.component';
import { SoftwareUpgradeSchedulingComponent } from './components/software-upgrade-scheduling/software-upgrade-scheduling.component';
import { ShoppingMagowebCardComponent } from './cards/shopping-magoweb-card/shopping-magoweb-card.component';
import { IndustriesListComponent } from './components/industries-list/industries-list.component';
import { FunctionalityIncludedComponent } from './components/functionality-included/functionality-included.component';
import { MagocloudCardComponent } from './cards/magocloud-card/magocloud-card.component';
import { MagowebCardComponent } from './cards/magoweb-card/magoweb-card.component';
import { CalSelectionComponent } from './components/cal-selection/cal-selection.component';
import { MagocloudSmallCardComponent } from './cards/magocloud-small-card/magocloud-small-card.component';
import { MagowebSmallCardComponent } from './cards/magoweb-small-card/magoweb-small-card.component';
import { MagocloudPersonalSubComponent } from './cards/magocloud-personal-sub/magocloud-personal-sub.component';
import { MagowebPersonalSubComponent } from './cards/magoweb-personal-sub/magoweb-personal-sub.component';
import { MwNfsCardComponent } from './cards/mw-nfs-card/mw-nfs-card.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { RankingManagementCardComponent } from './cards/ranking-management-card/ranking-management-card.component';
import { MyUsersCardComponent } from './cards/my-users-card/my-users-card.component';
import { InstancesSelectionComponent } from './components/instances-selection/instances-selection.component';
import { SnapshotsSelectionComponent } from './components/snapshots-selection/snapshots-selection.component';
import { MulticompanyCreationButtonComponent } from '../store/components/multicompany-creation-button/multicompany-creation-button.component';
import { TrainingCoursesCardComponent } from './cards/training-courses-card/training-courses-card.component';
import { TrainingPlansCardComponent } from './cards/training-plans-card/training-plans-card.component';
import { TrainingRequestCardComponent } from './cards/training-request-card/training-request-card.component';
import { ContactsCardComponent } from './cards/contacts-card/contacts-card.component';
import { HelpCenterProductsCardComponent } from './cards/help-center-products-card/help-center-products-card.component';
import { BugsReportReleaseNotesCardComponent } from './cards/bugs-report-release-notes-card/bugs-report-release-notes-card.component';
import { CasAccountComponent } from '../pages/cas-account/cas-account.component';
import { SuggestionsCardComponent } from './cards/suggestions-card/suggestions-card.component';
import { PasskeyCardComponent } from './cards/passkey-card/passkey-card.component';
import { HelpCenterProductsSmallCardComponent } from './cards/help-center-products-small-card/help-center-products-small-card.component';
import { PortalGuideCardComponent } from './cards/portal-guide-card/portal-guide-card.component';
import { ProductsCardComponent } from './cards/products-card/products-card.component';
import { MagoUniversityCardComponent } from './cards/mago-university-card/mago-university-card.component';
import { TechnicalSupportCardComponent } from './cards/technical-support-card/technical-support-card.component';
import { EditionsListComponent } from './components/editions-list/editions-list.component';
import { TicketingHDACardComponent } from './cards/ticketing-hda-card/ticketing-hda-card.component';
import { NewsListComponent } from './components/news-list/news-list.component';
import { IncidentsCatalogCardComponent } from './cards/incidents-catalog-card/incidents-catalog-card.component';
import { VerticalSolutionCryptSalesModulesCardComponent } from './cards/vertical-solution-crypt-sales-modules-card/vertical-solution-crypt-sales-modules-card.component';
import { VerticalSolutionSerialNumbersCardComponent } from './cards/vertical-solution-serial-numbers-card/vertical-solution-serial-numbers-card.component';
import { VerticalSolutionReportCardComponent } from './cards/vertical-solution-report-card/vertical-solution-report-card.component';
import { VerticalSolutionCardComponent } from './cards/vertical-solution-card/vertical-solution-card.component';
import { VerticalSolutionKeyCardComponent } from './cards/vertical-solution-key-card/vertical-solution-key-card.component';

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD-MM-YYYY',
    },
    display: {
        dateInput: 'DD-MM-YYYY',
        monthYearLabel: 'MM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MM YYYY',
    },
};
const COMPONENTS = [
    LoadingComponent,
    HeaderComponent,
    M4storeMessageComponent,
    Mago4VsMagocloudCardComponent,
    HelpStoreCardComponent,
    CMSCardComponent,
    CMSEditorIndustriesComponent,
    DatiFatturazioneComponent,
    ShoppingCompactCardComponent,
    ShoppingAmazonDSPCardComponent,
    AccountManagementCardComponent,
    SubscriptionManagementCardComponent,
    ImportExportManagementCardComponent,
    NfsCardComponent,
    GenericCardComponentComponent,
    DocCardComponentComponent,
    CountrySelectionComponent,
    IndustryHeaderComponent,
    FunctionalitiesSelectionComponent,
    FeatureElementComponent,
    A2fConfiguratorComponent,
    AccountFeaturesComponent,
    ShoppingAmazonDSPCardComponent,
    SpecializedFeaturesSelectionComponent,
    UserDocumentsListComponent,
    PrivacyAgreement,
    PartnersRegistryCardComponent,
    SoftwareUpgradeSchedulingComponent,
    ShoppingMagowebCardComponent,
    IndustriesListComponent,
    FunctionalityIncludedComponent,
    MagocloudCardComponent,
    MagowebCardComponent,
    MagocloudSmallCardComponent,
    MagowebSmallCardComponent,
    CalSelectionComponent,
    MagocloudPersonalSubComponent,
    MagowebPersonalSubComponent,
    MwNfsCardComponent,
    MagowebPersonalSubComponent,
    NotFoundComponent,
    RankingManagementCardComponent,
    MyUsersCardComponent,
    InstancesSelectionComponent,
    SnapshotsSelectionComponent,
    MulticompanyCreationButtonComponent,
    TrainingCoursesCardComponent,
    TrainingPlansCardComponent,
    TrainingRequestCardComponent,
    ContactsCardComponent,
    HelpCenterProductsCardComponent,
    BugsReportReleaseNotesCardComponent,
    CasAccountComponent,
    SuggestionsCardComponent,
    PasskeyCardComponent,
    HelpCenterProductsSmallCardComponent,
    PortalGuideCardComponent,
    ProductsCardComponent,
    MagoUniversityCardComponent,
    TechnicalSupportCardComponent,
    EditionsListComponent,
    TicketingHDACardComponent,
    NewsListComponent,
    IncidentsCatalogCardComponent,
    VerticalSolutionCryptSalesModulesCardComponent,
    VerticalSolutionSerialNumbersCardComponent,
    VerticalSolutionReportCardComponent,
    VerticalSolutionCardComponent,
    VerticalSolutionKeyCardComponent
];

const MATERIAL_UI_MODULES = [
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatBottomSheetModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatRadioModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatGridListModule,
    MatInputModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTabsModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatStepperModule,
    MatExpansionModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatTreeModule,
    MatDialogModule,
    MatButtonToggleModule,
    DragDropModule,
    MatFormFieldModule,
];

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const TRANSLATE_MODULE_CONFIG: TranslateModuleConfig = {
    loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
    },
};

@NgModule({
    declarations: [COMPONENTS],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MATERIAL_UI_MODULES,
        FontAwesomeModule,
        TranslateModule.forChild(TRANSLATE_MODULE_CONFIG),
        NgxIntlTelInputModule,
        SimpleNotificationsModule.forRoot(),
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        COMPONENTS,
        MATERIAL_UI_MODULES,
        FontAwesomeModule,
        TranslateModule,
        SimpleNotificationsModule,
    ],
})
export class SharedModule {
    static forRoot() {
        return {
            NgModule: SharedModule,
            providers: [
                UnsavedChangesGuard,
                {
                    provide: DateAdapter,
                    useClass: MomentDateAdapter,
                    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
                },
                {
                    provide: MAT_DATE_FORMATS,
                    useValue: MY_FORMATS,
                },
            ],
        };
    }
}
